'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeDonationTotals = exports.fetchDonationTotals = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var fetchDonationTotals = exports.fetchDonationTotals = function fetchDonationTotals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var mappings = {
    type: 'type'
  };

  return (0, _client.get)('api/v2/search/totals', params, { mappings: mappings });
};

var deserializeDonationTotals = exports.deserializeDonationTotals = function deserializeDonationTotals(totals, excludeOffline) {
  var offsetOffline = excludeOffline && totals.types.offline_donation;
  var raisedOffset = offsetOffline ? totals.types.offline_donation.total_amount_cents.sum || 0 : 0;
  var countOffset = offsetOffline ? totals.types.offline_donation.total_amount_cents.count : 0;

  return {
    raised: Math.max(0, (totals.total_amount_cents.sum || 0) - raisedOffset) / 100,
    donations: Math.max(0, totals.total_amount_cents.count - countOffset)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/donation-totals/everydayhero/index.js
// module id = 1405
// module chunks = 0